import { Toaster } from "@/components/ui/sonner";
import { StudyWorkspace } from "./components/Workspace";
import { CommunicationProvider } from "@/lib/CommunicationWrapper";
import { useCourses } from "@/lib/courses";
import { CourseNotebookController } from "./components/CourseNotebookController";
import { WithTheme } from "@/lib/WithTheme";

type Props = {};

export const StudyPage = (props: Props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const isSidebar = !!urlParams.get("filesai");
  const courseId = urlParams.get("course_id");
  const fileId = urlParams.get("file_id");
  const returnUrl = urlParams.get("return");
  return (
    <CommunicationProvider requiresLocalStorage={true}>
      <WithTheme />
      <CourseNotebookController
        isSidebar={isSidebar}
        courseId={courseId}
        fileId={fileId}
        returnUrl={returnUrl}
      />
      <Toaster />
    </CommunicationProvider>
  );
};
